<template>
	<div id="july-novated-promotion">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">
			July Novated Flex for Business Promotion
		</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					Offer available to eligible businesses and employers who
					sign up for carbar's novated subscription program from 1
					July 2025 to 31 July 2025.
				</li>
				<li>
					Offer applies to selected novated vehicles and only for the
					first 3 months of the subscription term.
				</li>
				<li>Offer available in NSW, VIC, and QLD only.</li>
				<li>
					To qualify, a valid ABN and employer verification is
					required.
				</li>
				<li>
					Cannot be combined with other carbar offers unless stated.
				</li>
				<li>
					If the novated subscription is cancelled before the 3-month
					period, the 10% discount will be forfeited. In addition,
					cancellation within the 3-month period may result in
					additional tax payments.
				</li>
				<li>
					Carbar reserves the right to withdraw or modify this
					promotion at any time.
				</li>
				<li>
					Standard novated subscription terms and approval processes
					apply.
				</li>
			</ul>
		</div>
	</div>
</template>
